// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { formatNumber } from '@/utilities/number';
import { Typography } from '@mui/material';

interface Props {
  /** What the order asked the vendor for. */
  plannedQuantity: number;
  /** What the third party reported as received, once the shipment is received. */
  receivedQuantity: number | null;
  /** Whether the shipment has been received. */
  isReceived: boolean;
}

/**
 * A shipment line's quantity: the received count once the shipment is received,
 * the planned count before then. Quarantine is surfaced by a separate chip, not
 * here, so the number reads plainly.
 */
export function ShipmentQuantityCell(props: Props) {
  const displayed =
    props.isReceived && props.receivedQuantity !== null
      ? props.receivedQuantity
      : props.plannedQuantity;

  return <Typography variant="body2">{formatNumber(displayed)}</Typography>;
}
